export default __webpack_public_path__ + "images/55_2_image.jpg";